import { Checkbox, Radio, Row } from 'antd'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { RadioChangeEvent } from 'antd/lib/radio'
import RentalCreateButton from 'app/components/Core/Rental/CreateButton'
import Table from 'app/components/Core/Rental/Table'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import TabBar from 'app/components/UI-Elements/Layout/TabBar/TabBar'
import { useCurrentContactOrganization } from 'app/lib/hooks/useCurrent'
import useFilterParams from 'app/lib/hooks/useFilterParams'
import { useQuery } from 'app/lib/hooks/useQuery'
import useTitle from 'app/lib/hooks/useTitle'
import useTranslation from 'app/lib/hooks/useTranslation'
import { PageProps } from 'app/pages/typing'
import { RENTAL_COUNT_QUERY } from 'app/queries/Rentals'
import { Routes } from 'app/routes/Routes'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export type RentalFilters = {
  scope: 'all' | 'me'
  excludeCanceled: boolean
}

const RentalsIndex: React.FC<PageProps> = (props) => {
  const { title } = useTitle(props)
  const { params, setSearchParams } = useFilterParams<RentalFilters>()

  const { scope, excludeCanceled } = params

  useEffect(() => {
    if (excludeCanceled === undefined) {
      setSearchParams({ ...params, excludeCanceled: true })
    }
  }, [])

  const navigate = useNavigate()
  const contactOrganization = useCurrentContactOrganization()
  const { tRoute } = useTranslation({ scope: props.route.key })

  const { data } = useQuery<{
    rentals: IPaginationMeta
  }>(RENTAL_COUNT_QUERY, {
    fetchPolicy: 'cache-first',
    variables: {
      isRequested: true,
      scope: 'all'
    }
  })

  const onRowClick = (rental: IRental) => {
    navigate(Routes.Rental.member(rental.id.toString()).show)
  }

  const onFilter = (e: RadioChangeEvent) => {
    setSearchParams({ ...params, scope: e.target.value })
  }

  const onChecked = (e: CheckboxChangeEvent) =>
    setSearchParams({ ...params, excludeCanceled: e.target.checked })

  const getDefaultScopeValue = (): RentalFilters['scope'] => {
    if (contactOrganization.role === 'accounting') {
      return 'all'
    } else {
      return 'me'
    }
  }

  const defaultScope = getDefaultScopeValue()

  return (
    <Row>
      <KCol span={24} card title={title}>
        <Row gutter={[0, 12]}>
          <If condition={contactOrganization}>
            <KCol span={24}>
              <Table
                showSearch
                filters={
                  <Radio.Group name="contact_id" value={scope || defaultScope} onChange={onFilter}>
                    <Radio.Button value="me" disabled={contactOrganization.role === 'accounting'}>
                      {tRoute({ id: 'my_rentals' })}
                    </Radio.Button>
                    <Radio.Button value="all">{tRoute({ id: 'all_rentals' })}</Radio.Button>
                  </Radio.Group>
                }
                filtersExtra={
                  <Checkbox onChange={onChecked} checked={excludeCanceled}>
                    {tRoute({ id: 'hide_canceled_rentals' })}
                  </Checkbox>
                }
                tableExtra={<RentalCreateButton />}
                hasRentals={data?.rentals?.total_count > 0}
                setFilter={(filter) => setSearchParams({ ...params, ...filter })}
                onRowClick={onRowClick}
                params={{
                  isRequested: true,
                  scope: defaultScope
                }}
              />
            </KCol>
          </If>
        </Row>
      </KCol>
      <TabBar selected={Routes.Rental.collection().index} />
    </Row>
  )
}

export default RentalsIndex
